import { extendObservable } from 'mobx';
import moment from 'moment';

class PolicyStore {
  initialState = {
    parametersLoaded: false,
    vigenciaStartDateMax: 180,
    vigenciaMaximaRetroativa: 1095,
    CotacaoGarantiaId: '', // ID da cotação
    ImportanciaSegurada: 0,
    Premio: 0,
    IdSegurado: null, // ID tribunal
    ContratoEdital: '', // Numero do Processo
    tribunal: null,
    DataVencimentoPrimeiraParcela: moment().add(7, 'days').format('YYYY-MM-DD'),
    AnexoEdital: '', // Reclamante
    NomeReclamante: '',
    CPFCNPJReclamante: '',
    cnpjSegurado: '',
    CEPReclamante: '',
    NeighborhoodReclamante: '',
    StreetReclamante: '',
    NumberReclamante: '',
    ComplementReclamante: '',
    PhoneReclamante: '',
    CityReclamante: '',
    StateReclamante: '',
    AddressIDReclamante: null,
    InicioVigencia: this.getDefaultInicioVigencia(),
    documentHash: null,
    documentSent: false,
    idDocumento: null,
    newInsured: false,
    IdEnderecoSegurado: null,
    QtdParcelas: 1,
    defaultObjectText: '',
    Proposal: {},
    Policy: {},
    coupon: null,
    creditsApplied: false,
    toggleNomeSocialReclamante: false,
    NomeSocialReclamante: '',
  };

  constructor() {
    extendObservable(this, { ...this.initialState });
  }

  /* istanbul ignore next */
  getDefaultInicioVigencia() {
    const date = moment().startOf('day');
    if (date.isDST()) {
      date.add(1, 'hour');
    }

    return date;
  }

  resetDocumentState() {
    const resetKeys = [
      'cotacaoGarantiaId',
      'QtdParcelas',
      'InicioVigencia',
      'NomeReclamante',
      'CPFCNPJReclamante',
      'cnpjSegurado',
      'AddressIDReclamante',
      'IdSegurado',
      'IdEnderecoSegurado',
      'AnexoEdital',
      'ContratoEdital',
      'idDocumento',
      'newInsured',
    ];

    resetKeys.forEach((rk) => {
      this[rk] = this.initialState[rk];
    });
  }
}

const policyStore = new PolicyStore();
/* istanbul ignore next line */
if (process.env.NODE_ENV === 'development') window.policyStore = policyStore;

export default policyStore;
